"use client";

import { Grid } from "@mantine/core";
import SchoolBranding from "./SchoolBranding";

export default function SchoolBrandingLayout() {
  const schoolData = [
    {
      name: "St Paul’s Co-educational College",
      imageName: "StPaulsCollege",
    },
    {
      name: "Dulwich College",
      imageName: "DulwichCollege",
    },
    {
      name: "St Joseph's Institution",
      imageName: "StJosephsInstitute",
    },
    {
      name: "Diocesan Boys’ School",
      imageName: "DiocesanBoys",
    },
    {
      name: "Sevenoaks School",
      imageName: "Sevenoaks",
    },
    {
      name: "Tanglin Trust School",
      imageName: "TanglinTrust",
    },
    {
      name: "German Swiss International School",
      imageName: "GermanSwissInternational",
    },
    {
      name: "Cheltenham Ladies College",
      imageName: "CheltenhamLadiesCollege",
    },
    {
      name: "Discovery College",
      imageName: "DiscoveryCollege",
    },
    {
      name: "North London Collegiate School Dubai",
      imageName: "NorthLondonCollegiateSchool",
    },
  ];
  return (
    <Grid grow mt={20} mb="xl" gutter="xl">
      {schoolData.map((school, indx) => (
        <Grid.Col key={indx} span={{ base: 12, md: 6 }}>
          <SchoolBranding {...school} />
        </Grid.Col>
      ))}
    </Grid>
  );
}
